import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[trimWhiteSpace]'
})
export class WhiteSpaceDirective {

    constructor(private _el: ElementRef, private _control: NgControl) { }

    @HostListener('change', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._control.control.setValue(initalValue.trim());
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}
